import callApi from "Common/utils/apiCaller";
import React, { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import Drawer from "../Drawer";
import {
  Download,
  Plus,
  Search,
  SlidersHorizontal,
  X,
  Rows4,
  GridIcon,
} from "lucide-react";
import _ from "lodash";
import ImageView from "../ImageView/ImageView";
import { getImageUrl } from "Common/utils/ImageDomain";
import Button from "../ButtonComponent/Button";
import { showNotification } from "Common/utils/Notification";
import CustomInput from "../InputFields/CustomInput";
import CustomTextArea from "../InputFields/CustomTextArea";

const BlogSegment = ({
  pageId,
  data,
  handleDelete,
  loader,
  setLoader,
  isEditable,
  versionData,
  segmentId,
  toggleVisiblity,
  segmentType = null,
}) => {
  const [headerText, setHeaderText] = useState(data?.heading);
  const [isLoading, setIsLoading] = useState<any>(false);

  const [description, setDescription] = useState(data?.text);
  const [errors, setErrors] = useState<any>({
    imageUrl: "",
  });
  const handleRemoveSegment = async (pageId, id) => {
    try {
      const res = await callApi(
        `v1/blog/${pageId}/blog-segment/${id}/remove-segment`,
        "post",
        {}
      );
      if (res.status === "Success") {
        showNotification("Segment removed successfully", "success");
        setLoader(!loader);
      }
    } catch (e) {
      showNotification("Error occured", "error");
    }
  };
  const handleSave = async (pageId, id) => {
    const payload = {
      segment_type: "blog_segments",

      heading: headerText,

      text: description,
    };

    try {
      setIsLoading(true);
      const response = await callApi(
        `v1/blog/${pageId}/segment/${id}/update-info`,
        "post",
        payload
      );
      setIsLoading(false);
      if (response && response?.status === "Success") {
        setLoader(!loader);
        showNotification("Blog segment added successfully!", "success");
      }
    } catch (e) {
      showNotification(
        "An error occurred while adding the video. Please try again.",
        "error"
      );
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="bg-white border border-black-600 rounded-[5px] px-8 py-4">
        <div className="mb-4 xl:col-span-12">
          <CustomInput
            label=" Header Text"
            name="heading"
            type="text"
            value={headerText}
            placeholder="Enter Header Text"
            onChange={(e) => {
              setHeaderText(e.target.value);
            }}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.heading}
          />
        </div>

        {/* <div className="mb-4 xl:col-span-12">
          <label className="inline-block mb-2 text-base font-medium">
            Sub Header Text
          </label>
          <input
            type="text"
            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
            placeholder="Enter Sub Header Text"
            value={subHeaderText}
            onChange={(e) => setSubHeaderText(e.target.value)}
          />
        </div> */}
        <div className="mb-4 xl:col-span-12">
          <CustomTextArea
            label="Description"
            name="text"
            value={description}
            placeholder="Enter Description"
            onChange={(value) => {
              setDescription(value);
            }}
            error={errors.text}
            isVersioned={versionData?.text ? true : false}
            versionedValue={versionData?.text}
          />
        </div>
        {/* Save Button */}
        <div className="flex justify-end gap-2 mt-4">
          <Button
            isLoading={isLoading}
            handleSave={handleSave}
            pageId={pageId}
            id={segmentId}
          />

          <button
            className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
            onClick={() => handleRemoveSegment(pageId, segmentId)}
          >
            Delete
          </button>
        </div>
      </div>
    </>
  );
};

export default BlogSegment;
